import { useEffect, useState } from "react";
import axios from "axios";
import "./Companies.css";

function Companies() {
  const [companies, setCompanies] = useState([]);

  const [formData, setFormData] = useState({
    company_name: "",
    nit: "",
    email: "",
    phone: "",
    plan: "",
    max_users: "",
    start_date: "",
    end_date: "",
    subdomain: "",
  });

  useEffect(() => {
    fetchCompanies();
  }, []);


  const fetchCompanies = async () => {
    const token = localStorage.getItem("token");

    // 👇 AQUÍ VA EL DEBUG (NO EN useEffect)
    console.log("TOKEN EN COMPANIES:", token);

    try {
      const res = await axios.get(
        "/api/companies/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCompanies(res.data);

    } catch (error) {
      console.log(error.response);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    try {
      await axios.post(
        "/api/companies/",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Empresa creada correctamente 🚀");

      fetchCompanies();

      setFormData({
        company_name: "",
        nit: "",
        email: "",
        phone: "",
        plan: "",
        max_users: "",
        start_date: "",
        end_date: "",
        subdomain: "",
      });

    } catch (error) {
      console.log(error.response);
      alert("Error al crear empresa ❌");
    }
  };

  return (
    <div className="companies-container">
      <h1 className="companies-header">Gestión de Empresas 🏢</h1>

      <form onSubmit={handleSubmit} className="companies-card">

        <div className="companies-grid">

          <div className="input-group">
            <input
              className="companies-input"
              name="company_name"
              placeholder=" "
              value={formData.company_name}
              onChange={handleChange}
              required
            />
            <label>Nombre empresa</label>
          </div>

          <div className="input-group">
            <input
              className="companies-input"
              name="nit"
              placeholder=" "
              value={formData.nit}
              onChange={handleChange}
              required
            />
            <label>NIT</label>
          </div>

          <div className="input-group">
            <input
              className="companies-input"
              name="email"
              placeholder=" "
              value={formData.email}
              onChange={handleChange}
              required
            />
            <label>Correo</label>
          </div>

          <div className="input-group">
            <input
              className="companies-input"
              name="phone"
              placeholder=" "
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <label>Teléfono</label>
          </div>

          <div className="input-group">
            <input
              className="companies-input"
              name="plan"
              placeholder=" "
              value={formData.plan}
              onChange={handleChange}
              required
            />
            <label>Plan</label>
          </div>

          <div className="input-group">
            <input
              className="companies-input"
              name="max_users"
              placeholder=" "
              value={formData.max_users}
              onChange={handleChange}
              required
            />
            <label>Máximo usuarios</label>
          </div>

          <div className="input-group">
            <input
              className="companies-input"
              type="date"
              name="start_date"
              value={formData.start_date}
              onChange={handleChange}
              required
            />
            <label>Fecha inicio</label>
          </div>

          <div className="input-group">
            <input
              className="companies-input"
              type="date"
              name="end_date"
              value={formData.end_date}
              onChange={handleChange}
              required
            />
            <label>Fecha fin</label>
          </div>

          <div className="input-group">
            <input
              className="companies-input"
              name="subdomain"
              placeholder=" "
              value={formData.subdomain}
              onChange={handleChange}
              required
            />
            <label>Subdominio</label>
          </div>

        </div>

        <button type="submit" className="companies-btn">
          Crear Empresa
        </button>

      </form>

      <hr />

      <h2 className="companies-title">Empresas Registradas</h2>

      <div className="companies-table-container">

        <table className="companies-table">
          <thead>
            <tr>
              <th>Empresa</th>
              <th>Email</th>
              <th>Plan</th>
              <th>Usuarios</th>
              <th>Subdominio</th>
            </tr>
          </thead>

          <tbody>
            {companies.map((company) => (
              <tr key={company.id}>
                <td className="company-name">
                  {company.company_name}
                </td>

                <td>{company.email}</td>

                <td>
                  <span className={`badge ${company.plan}`}>
                    {company.plan}
                  </span>
                </td>

                <td>{company.max_users}</td>

                <td>{company.subdomain}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Companies;